import { keyBy } from 'lodash'

import { getSubdomainInHash } from '../../utils/common'

export const topRoutes = [
  {
    id: 'eventRego',
    path: '/event/registration-form',
    title: 'Register',
    noExact: true,
  },
  {
    id: 'registrationForm',
    path: '/registration-form',
    title: 'Register',
    noExact: true,
  },
  {
    id: 'eventLandingPage',
    path: '/event/landing-page',
    title: 'Landing Page',
    noExact: true,
  },
  {
    id: 'landingPage',
    path: '/',
    title: 'Landing Page',
  },
  {
    id: 'membershipRego',
    path: '/:orgId/:formId',
    title: 'Register',
    noExact: true,
  },
  {
    id: 'paymentResponse',
    path: '/paymentResponse',
    title: 'Processing',
    noExact: true,
  },
  {
    id: 'paymentComplete',
    path: '/payment-complete',
    title: 'Payment Complete',
    noExact: true,
  },
]

export const createRegistrationPath = path => {
  if (window.location.hash.includes('event/landing-page') && getSubdomainInHash()) {
    // for new event landing page url
    return `${topRoutes[2].path}/${getSubdomainInHash()}/${path}`
    // eslint-disable-next-line no-else-return
  } else if (window.location.hash.includes('event/registration-form') && getSubdomainInHash()) {
    // for new event rego form url
    return `${topRoutes[0].path}/${getSubdomainInHash()}/${path}`
  } else {
    // keeping old event rego form url, old event landing page url, and membership rego form
    return `${topRoutes[1].path}/${path}`
  }
}

// For membership rego form
export const createPath = (path, { organisation, form, user }) =>
  `${path}/${organisation}/${form}${user ? `/${user}` : ''}`

export const secondRoutes = [
  {
    id: 'form',
    path: createRegistrationPath('form'),
    title: 'Form',
  },
  {
    id: 'signup',
    path: createRegistrationPath('signup'),
    title: 'Sign Up',
  },
  {
    id: 'signupSuccess',
    path: createRegistrationPath('signupsuccess'),
    title: 'Sign Up Success',
  },
  {
    id: 'signupGuest',
    path: createRegistrationPath('signupGuest'),
    title: 'Sign Up Guest',
  },
  {
    id: 'forgotPassword',
    path: createRegistrationPath('forgotPassword'),
    title: 'Forgot Password',
  },
  {
    id: 'resetPassword',
    path: createRegistrationPath('resetPassword'),
    title: 'Reset Password',
  },
  {
    id: 'verifyEmail',
    path: createRegistrationPath('verify'),
    title: 'Verify Email',
  },
  {
    id: 'login',
    path: createRegistrationPath(''),
    title: 'Login',
  },
  {
    id: 'paymentComplete',
    path: createRegistrationPath('paymentComplete'),
    title: 'Payment Complete',
  },
]

export const privateRoutes = isTeamEvent => [
  {
    id: 'teams',
    title: 'Team Details',
  },
  {
    id: 'participants',
    title: 'Participants',
  },
  {
    id: 'basicInfo',
    title: 'Basic Info',
  },
  {
    id: 'products',
    title: isTeamEvent ? 'Team Products' : 'Products',
  },
  {
    id: 'subEvents',
    title: 'Sub Events',
  },
  {
    id: 'addOnProducts',
    title: isTeamEvent ? 'Team Add-ons' : 'Add-ons',
  },
  {
    id: 'questions',
    title: isTeamEvent ? 'Team Questions' : 'Questions',
  },
  {
    id: 'summary',
    title: 'Summary',
  },
  {
    id: 'payment',
    title: 'Payment',
  },
  {
    id: 'success',
    title: 'Success',
  },
]

const routesMap = keyBy(topRoutes, r => r.id)
const registrationRoutesMap = keyBy(secondRoutes, r => r.id)
export default { ...routesMap, ...registrationRoutesMap }
